<template>
  <b-container fluid class="text-converter">
    <b-row>
      <b-col>
        <div class="converter-select-container">
          <!-- <b-form-select v-model="selectedType" :options="convertTypes" class="col-2 convert-type-select">
          </b-form-select> -->
          <b-dropdown
            v-if="convertTypes.length > 0"
            id="ddown-header"
            :text="convertTypes.filter(t => t.value === selectedType)[0].text"
            class="m-2 convert-type-select"
          >
            <b-dropdown-item-button
              v-for="(type, index) in convertTypes"
              :key="index"
              @click="selectedType = type.value"
            >
              {{ type.text }}
            </b-dropdown-item-button>
          </b-dropdown>
          <b-button class="convert" @click.prevent="convertContent()">
            {{ ls_Convert }}
          </b-button>
          <div class="custom-control custom-checkbox float-right is-follow">
            <input
              class="form-check-input custom-control-input"
              v-model="isFollow"
              type="checkbox"
              id="isFollow"
              value="true"
            />
            <label
              class="form-check-label custom-control-label"
              for="isFollow"
              >{{ ls_Instant }}</label
            >
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="ctrl-dir">
      <b-col cols="6">
        <awesome-textarea ref="editor">
          <textarea
            ref="convertTextarea"
            class="convert-textarea"
            v-model="contentText"
            :maxlength="contentMaxLength"
            :style="
              selectedType.includes('tote2')
                ? 'font-family: KazNet, Arial !important; direction: rtl; text-align: right;'
                : ''
            "
            @select="getCaretPosition"
            @focus="getCaretPosition"
            spellcheck="false"
            @keypress="pressKazakh"
            @keydown="downKey"
            @keyup="upKey"
          ></textarea>
        </awesome-textarea>
        <p class="convert-features">
          <span class="clear-btn" @click="clearContent()">
            <i class="fal fa-times-circle"></i>
          </span>
          <span class="word-count">
            {{ contentText.length }} / {{ contentMaxLength }}
          </span>
          <span class="keyboard-icon" @click="showKeyboard = !showKeyboard">
            <i class="fal fa-keyboard"></i>
          </span>
        </p>
        <Keyboard
          v-show="showKeyboard"
          :baseText="contentText"
          :bindElement="$refs.convertTextarea"
          :mapName="mapName"
          :hoverKey="hoverKey"
          @closeKeyboard="closeKeyboard"
          @keypressing="keypressing"
        />
      </b-col>
      <b-col cols="6">
        <div
          class="converted-area"
          v-html="convertedText.replace(/\n/g, '<br />')"
          :style="
            selectedType.includes('2tote')
              ? 'font-family: KazNet, Arial !important; direction: rtl; text-align: right;'
              : ''
          "
        ></div>
        <p class="convert-features">
          <span
            class="copy-btn"
            ref="copy"
            data-clipboard-action="copy"
            :data-clipboard-text="convertedText"
            @click="copyContent"
          >
            <i class="fal fa-copy"></i>
          </span>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AwesomeTextarea from "@/assets/js/awesometextarea.js";
import Vue from "vue";
import Keyboard from "@/components/Keyboard.vue";
import keyCodesMap from "@/assets/js/map.js";

export default {
  data() {
    return {
      mapName: "english",
      showKeyboard: false,
      caretposition: [0, 0],

      selectedType: "",
      convertTypes: [],
      contentText: "",
      contentMaxLength: 5000,
      convertedText: "",
      isFollow: false,
      copyBtn: null,

      keyMap: "default",
      hoverKey: null
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_Convert() {
      return this.$store.state.languagePack.ls_Convert;
    },
    ls_Instant() {
      return this.$store.state.languagePack.ls_Instant;
    },
    ls_TextConverter() {
      return this.$store.state.languagePack.ls_TextConverter;
    }
  },

  mounted() {
    this.getConvertTypes();
    this.copyBtn = new this.Clipboard(this.$refs.copy);

    if (localStorage.getItem("isFollow") !== null) {
      this.isFollow =
        localStorage.getItem("isFollow") === "true" ? true : false;
    }

    // this.$refs.convertTextarea.addEventListener("keydown", e => {
    //   let ev = e ? e : window.event;
    //   let keyCode = ev.keyCode ? ev.keyCode : ev.which;

    //   if (keyCode === 75 && ev.ctrlKey && ev.altKey) {
    //     this.keyMap = "kazakhCyrl";
    //   } else if (keyCode === 76 && ev.ctrlKey && ev.altKey) {
    //     this.keyMap = "kazakhLatyn";
    //   } else if (keyCode === 84 && ev.ctrlKey && ev.altKey) {
    //     this.keyMap = "kazakhTote";
    //   } else if (keyCode === 68 && ev.ctrlKey && ev.altKey) {
    //     this.keyMap = "default";
    //   }
    // });
  },

  methods: {
    isExistKey(keyCode) {
      for (let c in keyCodesMap[this.keyMap]) {
        if (c.charCodeAt(0) === keyCode) {
          return true;
        }
      }
      return false;
    },
    downKey(e) {
      if (this.showKeyboard) {
        e = e ? e : window.event;
        let keyCode = e.keyCode ? e.keyCode : e.which;
        this.hoverKey = keyCode === 32 ? " " : keyCode;
        // console.log(this.hoverKey);
      }
    },
    upKey() {
      if (this.hoverKey !== null) {
        this.hoverKey = null;
      }
    },
    pressKazakh(e) {
      if (this.keyMap !== "default" && this.showKeyboard) {
        e = e ? e : window.event;
        let keyCode = e.keyCode ? e.keyCode : e.which;
        let mapLocation = e.location ? e.location : 0;
        let text =
          this.isExistKey(keyCode) && mapLocation === 0
            ? String.fromCharCode(
                keyCodesMap[this.keyMap][String.fromCharCode(keyCode)]
              )
            : String.fromCharCode(keyCode);
        this.insertChar(text);
        e.preventDefault();
        if (this.showKeyboard) {
          this.hoverKey = text;
        }
      }
    },

    insertChar(text) {
      let contentText = this.contentText,
        postion = {
          start: this.$refs.convertTextarea.selectionStart,
          end: this.$refs.convertTextarea.selectionEnd
        };

      contentText =
        contentText.substring(0, postion.start) +
        text +
        contentText.substring(postion.end);

      this.keypressing({
        text: contentText,
        position: [postion.start + 1, postion.start + 1]
      });
    },
    getCaretPosition() {
      let position = [
        this.$refs.convertTextarea.selectionStart,
        this.$refs.convertTextarea.selectionEnd
      ];

      if (position.end < position.start || position.end - position.start < 2) {
        position.end = position.start;
      }
      this.caretposition = position;
    },

    keypressing(obj) {
      this.contentText = obj.text;

      let timer = setTimeout(() => {
        this.caretposition = [obj.position[0], obj.position[1]];
        this.$refs.convertTextarea.setSelectionRange(
          obj.position[0],
          obj.position[0]
        );
        this.$refs.convertTextarea.blur();
        this.$refs.convertTextarea.focus();
        clearTimeout(timer);
      }, 10);
    },

    closeKeyboard() {
      this.showKeyboard = false;
    },

    getConvertTypes() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getconverttypelist", fd)
        .then(result => {
          if (result.status === 200) {
            this.convertTypes = [];
            result.body.data.forEach(item =>
              this.convertTypes.push({
                value: item.convertKey,
                text: item.convertValue
              })
            );
            this.selectedType = this.convertTypes[0].value;
          } else {
            // console.log('Err');
          }
        });
    },
    convertContent() {
      if (this.contentText !== "" && this.contentText !== null) {
        let formatedContent = this.contentText;
        let fd = new FormData();
        fd.append("convertType", this.selectedType);
        fd.append("text", formatedContent);
        this.$http.post(this.host + "/api/convert/text", fd).then(result => {
          if (result.status === 200) {
            this.convertedText = result.body.data;
          }
        });
      }
    },
    clearContent() {
      this.contentText = "";
      this.convertedText = "";
      this.$refs.editor.$el.style.height = "10rem";
    },
    copyContent() {
      let clipboard = this.copyBtn;
      let ls_SuccessfullyCopied = this.$store.state.languagePack
        .ls_SuccessfullyCopied;

      clipboard.on("success", function() {
        Vue.notify({
          group: "qazlatyn",
          title: "",
          text: ls_SuccessfullyCopied
        });
      });
      clipboard.on("error", function() {
        // console.log('Err');
      });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getConvertTypes();
      }
    },

    contentText(newContent, oldContent) {
      if (newContent === oldContent) return;

      if (newContent.trim().length < 1) return;

      if (newContent.length > this.contentMaxLength) {
        this.contentText = newContent.substring(0, this.contentMaxLength);
      }

      if (this.isFollow.toString() === "true") {
        if (convertTimeout) {
          clearTimeout(convertTimeout);
        }
        let convertTimeout = setTimeout(() => {
          this.convertContent();
        }, 700);
      } else {
        this.convertedText = "";
      }
    },

    isFollow(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (localStorage.getItem("isFollow") !== null) {
          localStorage.removeItem("isFollow");
        }
        localStorage.setItem("isFollow", this.isFollow);
      }
    },

    selectedType(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (newVal.includes("latyn2")) {
        this.mapName = "kazakhLatyn";
        this.keyMap = "kazakhLatyn";
      } else if (newVal.includes("tote2")) {
        this.mapName = "kazakhTote";
        this.keyMap = "kazakhTote";
      } else if (newVal.includes("cyrl2")) {
        this.mapName = "kazakhCyrl";
        this.keyMap = "kazakhCyrl";
      } else {
        this.mapName = "english";
        this.keyMap = "default";
      }
    }
  },

  metaInfo() {
    return {
      title: this.ls_TextConverter
    };
  },

  components: {
    "awesome-textarea": AwesomeTextarea,
    Keyboard
  }
};
</script>

<style lang="scss">
.text-converter {
  margin-bottom: 1rem;

  .convert.btn-secondary {
    background-color: #038395;
    border-color: #038395;
    font-weight: 500;
    margin-left: 16px;
    border-radius: 3px;

    &:active,
    &:hover,
    &:focus,
    &:active:focus,
    &:not(:disabled):not(.disabled):active:focus {
      background: #006b75;
      border-color: 0;
      box-shadow: none;
    }
  }
  .converter-select-container {
    margin-bottom: 18px;

    .custom-control {
      margin-top: 15px;
    }

    .custom-select {
      background: #fff
        url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 129 129'%3E%3Cpath fill='%23343a40' d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z'/%3E%3C/svg%3E")
        no-repeat right 0.75rem center;
      background-size: 1.125rem 1.125rem;

      &:focus {
        box-shadow: none;
      }
    }

    .convert-type-select {
      width: 200px;
      margin: 0 0 0 -1px !important;

      .dropdown-menu {
        width: 100%;
        border-radius: 3px;

        .dropdown-item {
          padding: 4px 12px;

          &:focus {
            outline: none;
          }

          &:hover {
            background-color: #00849022;
          }
        }
      }

      .dropdown-toggle {
        border-color: #ced4da;
        color: #706f70;
        width: 100%;
        text-align: left;
        border-radius: 3px;
        background: #f6f6f6
          url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 129 129'%3E%3Cpath fill='%23343a40' d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z'/%3E%3C/svg%3E")
          no-repeat right 0.75rem center;
        background-size: 14px 14px;

        &:focus {
          outline: none !important;
          box-shadow: none !important;
          background-color: transparent;
          color: #706f70;
        }

        &::after {
          border: none !important;
        }
      }
    }

    .is-follow {
      .custom-control-input:checked ~ .custom-control-label::before,
      .custom-control-input:checked ~ .custom-control-label::after,
      .custom-control-input:focus ~ .custom-control-label::before {
        background-color: #006b75;
        box-shadow: none;
        border-radius: 3px !important;
      }
    }
  }
}
.convert-textarea {
  border: 1px solid #b0b2b4;
  padding: 0.375rem 0.75rem;
  padding-bottom: 1.5rem;
  margin-right: -5px !important;
  width: 100%;
  min-height: 10rem;
  background-color: #ffffff;
  color: #706f70;
  font-family: Roboto, Arial, Helvetica, sans-serif, KazNet;
  resize: none;
  overflow: hidden;
  transition: all 300ms ease-in-out;

  &:focus {
    color: #212525;
    background-color: #fff;
    border-color: #006b75;
    outline: 0;
    box-shadow: none;
  }

  // &::selection {
  //   color: #008490;
  // }
}
.convert-features {
  position: relative;
  margin-bottom: 0;
  margin-top: -34px;
  font-size: 1rem;
  color: #706f70;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  .word-count,
  .keyboard-icon {
    position: absolute;
    top: 5px;
    cursor: pointer;
  }
  .word-count {
    right: 2.5rem;
    font-size: 12px;
  }
  .keyboard-icon {
    right: 0.5rem;
    font-size: 16px;
    line-height: 18px;

    &:hover,
    &:focus {
      color: #212525;
    }
  }

  .copy-btn {
    font-size: 1rem;
  }

  .clear-btn {
    :hover {
      color: #212525;
    }
  }

  .copy-btn:hover,
  .copy-btn:focus {
    color: black;
    font-size: 1rem;
  }
}
.converted-area {
  min-height: 10rem;
  border: 1px solid #b0b2b4;
  padding: 0.375rem 0.75rem;
  padding-bottom: 1.5rem;
  margin-bottom: 5px;
  margin-left: -5px !important;
  color: #777;
  font-family: Roboto, Arial, Helvetica, sans-serif, KazNet;
  background: #f6f6f6;
  overflow-x: hidden;
}

/* RTL */

.rtl-layout {
  .converter-select-container {
    direction: rtl;
    text-align: right;

    .custom-select {
      padding: 6px 12px 6px 28px;
      // background: #fff no-repeat left 0.75rem center;
      background-position: 10px 8px;
    }

    .file-upload-title {
      direction: rtl;
      text-align: right;
      margin-right: 48px;
      margin-left: 0px;
    }

    .convert.btn-secondary {
      margin-right: 16px;
      margin-left: 0;
    }

    .custom-control {
      direction: rtl;
      float: left !important;
      padding: 0 24px 0 0;

      .custom-control-label {
        &::after,
        &::before {
          right: -24px;
        }
      }
    }
  }
}
</style>
